import { render, staticRenderFns } from "./BrickCustomConditions.vue?vue&type=template&id=bdbde8c8&scoped=true&"
import script from "./BrickCustomConditions.vue?vue&type=script&lang=js&"
export * from "./BrickCustomConditions.vue?vue&type=script&lang=js&"
import style0 from "./BrickCustomConditions.vue?vue&type=style&index=0&id=bdbde8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbde8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdbde8c8')) {
      api.createRecord('bdbde8c8', component.options)
    } else {
      api.reload('bdbde8c8', component.options)
    }
    module.hot.accept("./BrickCustomConditions.vue?vue&type=template&id=bdbde8c8&scoped=true&", function () {
      api.rerender('bdbde8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/BrickCustomConditions.vue"
export default component.exports